import React, {useEffect, useRef, useState} from "react";

import axios from "config/axiosConfig";
import dateFormat from "dateformat";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";

const nowYear = () => {
    const now = new Date();
    return now.getFullYear();
}

function List() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";
    const searchBizName = searchParams.get('searchBizName');
    const searchMembership = searchParams.get('searchMembership');

    const navigate = useNavigate();

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    const requestSearch = () => {
        const params = {};
        params.page = page;
        params.bizName = searchBizName;
        params.membership = searchMembership;

        axios.get(`/admin/bizes`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    };

    const navigateToDetail = (bizId) => {
        let uri = `/page/salary/detail?bizId=${bizId}`;
        navigate(uri);
    };

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">급여관리 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <button type="submit" className="btn btn-info float-right"
                                                    style={{width: '80px', marginRight: '10px'}}
                                                    onClick={() => {
                                                        setPage(1);
                                                        requestSearch();
                                                    }}>
                                                검색
                                            </button>

                                            <select className="form-control float-right"
                                                    style={{width: '200px', marginRight: '10px'}}
                                                    onChange={(e) => {
                                                        searchParams.set('searchMembership', e.target.value);
                                                        setSearchParams(searchParams);
                                                    }}
                                                    value={searchMembership}>
                                                <option value="BUSINESS">BUSINESS</option>
                                                <option value="BASIC">BASIC</option>
                                                <option value="">ALL</option>
                                            </select>
                                            <label htmlFor="inputBizName"
                                                   className="col-form-label float-right"
                                                   style={{marginRight: '10px'}}>멤버십 </label>

                                            <input id="inputBizName" type="text" className="form-control float-right"
                                                   placeholder="사업장명"
                                                   style={{width: "200px", textAlign: "right", marginRight: '30px'}}
                                                   name="bizName"
                                                   onChange={(e) => {
                                                       searchParams.set('searchBizName', e.target.value);
                                                       setSearchParams(searchParams);
                                                   }}
                                                   onKeyDown={ (e) => {
                                                       if (e.key === "Enter") {
                                                           setPage(1);
                                                           requestSearch();
                                                       }
                                                   }}
                                                   value={searchBizName}
                                            />
                                            <label htmlFor="inputBizName"
                                                   className="col-form-label float-right"
                                                   style={{marginRight: '10px'}}>사업장명 </label>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>bizId</th>
                                                    <th>사업자명</th>
                                                    <th>사업자번호</th>
                                                    <th>대표자</th>
                                                    <th>멤버십</th>
                                                    <th>멤버십상태</th>
                                                    <th>관리</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents.map(item => {
                                                        return(
                                                                <tr key={item.id}>
                                                                    <td>{item.id}</td>
                                                                    <td>{item.name}</td>
                                                                    <td>{item.number}</td>
                                                                    <td>{item.ceoName}</td>
                                                                    <td>{item.membership}</td>
                                                                    <td>{item.membershipStatusDesc}</td>
                                                                    <td>
                                                                        <button type="button"
                                                                                className="btn btn-outline-primary btn-sm"
                                                                                style={{width: '70px'}}
                                                                                onClick={() => navigateToDetail(item.id)}>
                                                                            보기
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        { paginationDto && <Pagination pager={paginationDto} setPage={setPage}/> }

                    </section>
                </div>
            </div>
        </div>
    );
}

export default List;
